module.exports = __webpack_public_path__ + "static/media/GERSMarkdown.627cf83c.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/GERSModel/GERSMarkdown.md
// module id = 1109
// module chunks = 0